var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"modal modal__backdrop",on:{"click":_vm.checkClose}},[_c('div',{staticClass:"modal__content"},[_c('font-awesome-icon',{staticClass:"modal__close",attrs:{"icon":'times-circle'},on:{"click":function($event){return _vm.$emit('close')}}}),_vm._t("content")],2)])
}
var staticRenderFns = []

export { render, staticRenderFns }